import { API } from 'aws-amplify';
import React, { Component } from 'react';

const publicIp = require('public-ip');

class OptOut extends Component {

  constructor(props) {
    super(props);

    this.headerTextStyle = {
      textAlign: "left",
      fontSize: "14px"
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      email: "",
      phone: "",
      notes: "",
      data: [],
      completed: false,
      loading: false,
      errors: { email: "", phone: "" }
    };

  }

  handleInputChange(event) {
    const target = event.target;
    const name = target.name;
    const value = name === "phone" ? this.formatPhone(target.value) : target.value;
    this.setState(prev => ({
      [name]: value,
      errors: { ...prev.errors, [name]: "" }   // clear the field's error as the user types
    }));
  }

  validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || "").trim());
  }

  // Digits of a US number, without the optional leading 1. "" when none were typed.
  phoneDigits(phone) {
    const digits = (phone || "").replace(/\D/g, "");
    return digits.length === 11 && digits.charAt(0) === "1" ? digits.slice(1) : digits;
  }

  // Formats as the user types: (555) 555-4444, or 1 (555) 555-4444 if they typed the 1.
  formatPhone(phone) {
    let digits = (phone || "").replace(/\D/g, "");
    let prefix = "";

    if (digits.charAt(0) === "1") {
      prefix = "1";
      digits = digits.slice(1);
    }
    digits = digits.slice(0, 10);

    if (!digits) return prefix;
    if (prefix) prefix = "1 ";

    if (digits.length < 4) return `${prefix}(${digits}`;
    if (digits.length < 7) return `${prefix}(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `${prefix}(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  validatePhone(phone) {
    if (!(phone || "").trim()) return true;   // optional field — blank is valid
    return this.phoneDigits(phone).length === 10;
  }

  errorFor(name, value) {
    if (name === "email") {
      return this.validateEmail(value) ? "" : "Please enter a valid email address.";
    }
    if (name === "phone") {
      return this.validatePhone(value)
        ? ""
        : "Please enter a valid 10-digit U.S. phone number, or leave it blank.";
    }
    return "";
  }

  handleBlur(event) {
    const { name, value } = event.target;
    this.setState(prev => ({ errors: { ...prev.errors, [name]: this.errorFor(name, value) } }));
  }

  success(res) {
    this.setState({
      completed: true
    })
  }

  asyncSubmit = async() => {
    this.setState({
      loading: true
    })
    try {
      await API.post('optout', `/optout`, {
        body: {
          email: this.state.email,
          phone: this.phoneDigits(this.state.phone),
          notes: this.state.notes,
          ip: await publicIp.v4()
        }
      }).then(
        res=>this.success(res)
      );
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({
        loading: false
      })
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    const errors = {
      email: this.errorFor("email", this.state.email),
      phone: this.errorFor("phone", this.state.phone)
    };
    this.setState({ errors });

    if (!errors.email && !errors.phone) {
      this.asyncSubmit();
    }
  }

  thankYou() {
    return (
      <div className="inner">
          <header className="page-header">
            <h1>Request Received</h1>
          </header>
          <p>Thank you &mdash; we&rsquo;ve received your opt-out request.</p>
          <p>Please allow up to <strong>10 business days</strong> for your request to be processed and for you to be removed from our marketing communications, including email, telephone calls, and SMS/text messages. You may still receive messages that were already scheduled or in progress during this short processing period.</p>
          <p>If your request also included a California privacy request (such as access to or deletion of your information), we will respond as required by applicable law, generally within 30 business days. We may need to verify your identity before we can disclose or delete information.</p>
          <p>If you have any questions about your request, contact us at <a href="mailto:privacy@reliancelitigation.com">privacy@reliancelitigation.com</a>.</p>
      </div>
    )
  }

  optOutForm() {
    return (
      <div className="inner">
          <header className="page-header">
            <h1>Opt-Out Request Form</h1>
          </header>
          <p style={this.headerTextStyle}>To opt-out of our marketing list from Reliance Litigation, please complete the form below or contact us at privacy@reliancelitigation.com. If your email address is in our system, we will verify and remove it from our marketing list. If you also provide your phone number, we will remove it from our telephone and SMS/text message lists.</p>
          <p style={this.headerTextStyle}>If you're a California resident, you may also request information that we've collected about you or request deletion of your information by stating below in your message or contacting us directly privacy@reliancelitigation.com.  We may have to verify that you are a Californian resident before we can disclose or delete this information beforehand.</p>
          <form onSubmit={this.handleSubmit} autoComplete="on" id="form" className="opt-out-form" noValidate>
            <div className="field">
              <label htmlFor="email">Email Address <span aria-hidden="true">*</span></label>
              <input required type="email" name="email" id="email" placeholder="you@example.com" value={this.state.email} onChange={this.handleInputChange} onBlur={this.handleBlur} aria-invalid={this.state.errors.email ? "true" : "false"} aria-describedby={this.state.errors.email ? "email-error" : undefined} />
              {this.state.errors.email && <p className="field-error" id="email-error" role="alert">{this.state.errors.email}</p>}
            </div>
            <div className="field">
              <label htmlFor="phone">Phone Number (optional)</label>
              <input type="tel" name="phone" id="phone" inputMode="tel" autoComplete="tel" maxLength="17" placeholder="(555) 555-4444" value={this.state.phone} onChange={this.handleInputChange} onBlur={this.handleBlur} aria-invalid={this.state.errors.phone ? "true" : "false"} aria-describedby={this.state.errors.phone ? "phone-error" : undefined} />
              {this.state.errors.phone && <p className="field-error" id="phone-error" role="alert">{this.state.errors.phone}</p>}
            </div>
            <div className="field">
              <label htmlFor="notes">Message (optional)</label>
              <textarea name="notes" id="notes" rows="4" placeholder="Add any details about your request" value={this.state.notes} onChange={this.handleInputChange} />
            </div>
            <div className="field">
              <input type="submit" value="Submit Request" id="submit_button" className="primary" />
              {this.state.loading && <span className="form-status" role="status"> Sending&hellip;</span>}
            </div>
            <p className="form-note"><span aria-hidden="true">*</span> Required field.</p>
          </form>
      </div>
    )
  }

  render() {
    return (
      <div id="main" className="wrapper">
        {this.state.completed ? this.thankYou() : this.optOutForm()}
      </div>
    );
  }

}

export default OptOut;
